var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckTickDouble = function SvgCheckTickDouble(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "m1.631 8.218 3.122 3.119.25-.437a17.8 17.8 0 0 1 5.412-5.861l.55-.376m3.404.41-.58.327a17.795 17.795 0 0 0-5.892 5.38l-.285.413-.199-.235"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckTickDouble);
export default ForwardRef;